

export default {
	home: 'ལྡེབ་ངོས་མགོ་མ་',
	hosintro: 'ཀུང་སིའི་སྐོར་གྱི་གནས་ཚུལ་མདོར་བསྡུས་',
	departmentnav: 'ཚན་ཁག་ཕྱོགས་སྟོན་',
	expertintro: 'རིགས་གཅིག་མཁས་ཅན་གྱིས་ངོ་སྤྲོད་བྱས་པར་གཞིགས་ན་',
	hosdynamic: 'སྨན་ཁང་འགུལ་རྣམ་',
	appointment: 'སྔོན་མངག་ཨང་ཀི་འགོད་པ་།',
	joinus: 'གདན་ཞུའི་ཆ་འཕྲིན',
	routenav: 'སྨན་ཁང་ནས་ཕྱོགས་སྟོན་',
	notice: 'སྨན་ཁང་གི་སྤྱི་བསྒྲགས་།',
	news: 'གསར་འགྱུར་ལྟེ་གནས་',
	media: 'སྨྱན་གཟུགས་འདུས་པ་ནི་',
	opentender: 'སྒྲུབ་འགན་འཁུར་མཁན་འགུགས་པའི་མཚམས་སྦྱོར་བརྡ་ཁྱབ་',
	more: 'དེ་ལས་མང་པོ་',
	msg: 'དཔྱད་ཡིག་ཆ་འཕྲིན་',
	ms: 'བརྡ་འཕྲིན་',
	honor: 'སྙན་གྲགས་',
	Process: 'བཟོ་རིམ་རི་མོ་',
	job: 'གདན་ཞུའི་ལས་གནས་',
	tomail: 'གལ་ཏེ་ཁྱེད་ཀྱིས་ཆེད་མངགས་ལ་། ལོ་རྒྱུས་མདོར་བསྡུས་ནས་ཡིག་སྒམ་རོགས་།',
	friendlink: 'གྲོགས་པའོ་འཕྲིན་སྦྲེལ་བྱེད་',
	address: 'ས་གནས་',
	tel: 'ཁ་པར་',
	jobdetail: 'ལས་གནས་གནས་ཚུལ་གསལ་བོ་ཤེས་འདོད་ན་',
	position: 'ལས་གནས་',
	personnum: 'མི་འབོར་',
	edu: 'ཡོན་ཚད་',
	place: 'ལས་ཀ་བྱེད་ས་',
	salary: 'གླ་ཕོགས་',
	requirements: 'ལས་ཀའི་བླང་བྱ་།',
	workexperience: 'ལས་ཀའི་ཉམས་མྱོང་',
	expert: 'ཆེད་ལས་མཁས་པ་',
	k: '',
	xzzzqdermyy: 'བོད་རང་སྐྱོང་ལྗོངས་མི་དམངས་སྨན་ཁང་གཉིས་པར་',
	qdndjr: 'རེ་སྒུག་བྱེད་ཀྱི་རང་གི་ནང་ཞུགས་།',
	contactus: 'ང་ཚོ་དང་འབྲེལ་བ་།',
	mail: 'སྦྲག་སྒམ་',
	department: 'ཁོ་ཧྲི་',
	professionaltitle: 'མཚན་གནས་',
	famous: 'མཁས་པ་',
	detailintro: 'ཞིབ་ཕྲས་ངོ་སྤྲོད་བྱས་།',
	gethonor: 'མཚན་སྙན་ཐོབ་།'
}


// WEBPACK FOOTER //
// ./src/utils/zang.js